import { postPixelEvent } from "../../Helpers/pixelRequest";
import React, { Component } from "react";

import {
  add_to_cart,
  edit_quantity,
  remove_from_cart,
} from "../../store/actions";
import { connect } from "react-redux";

import Button from "@material-ui/core/Button";

import Grid from "@material-ui/core/Grid";
import AddCircleOutline from "@material-ui/icons/AddCircleOutline";
import RemoveCircleOutline from "@material-ui/icons/RemoveCircleOutline";
import AddOutlined from "@material-ui/icons/AddOutlined";
import {
  isNotExcludedProuduct,
  preciseNumber,
} from "../../store/reducers/cart";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import { withRouter } from "react-router";

import ReactPixel from "@bettercart/react-facebook-pixel";
import SnapchatPixel from "react-snapchat-pixel";
import ReactAckoo from "../../ackoo";
import ReactGA from "react-ga4";
import TiktokPixel from "../../tiktok-pixel";
import TwitterPixel from "../../TwitterPixel";
import { GTM } from "../../App";
import { getMaximumProductInventoryFromModifiers } from "../Menu/Helpers";
import ConfirmationMessageDialog from "../ProductDetails/ConfirmationMessageDialog";
import ScheduledAvailableMessage from "../ProductDetails/ScheduledAvailableMessage";
import MingledDialog from "../ProductDetails/MingledDialog";
import { getParentCategories } from "../Menu/Helpers";
import moment from "moment";
import { getDHLQuote, getAramexRate } from "../../store/actions/shipping";
import { getProductInventory } from "../../store/reducers/store";
import {
  generateUniqueID,
  getFacebookTestID,
  PinterestAddToCart,
  SnapchatAddToCart,
} from "../../Helpers/analytics";
import Klaviyo from "../../Klaviyo";
import { compareTime } from "../Branches/ContactPageTools";
import StoreClosedDialog from "../ProductDetails/StoreClosedDialog";
import PinterestPixel from "../../PinterestPixel";
import {
  canAddToCartBeforeBranchSelection,
  getBuyNowCheckoutRoute,
} from "../../Helpers/orderPass";
import { isCheckoutV2Enabled, isEnabledFlag } from "../../checkout-v2/domain/featureFlags";
import "./QuickAddToCart.css";

export class QuickAddToCart extends Component {
  quantityToBededucted = 0;
  state = {
    item: null,
    itemIndex: -1,
    quantity: 0,
    changingQuantity: false,
    confirmationMessageOpen: false,
    MingledDialogOpen: false,
    scheduledAvailabilityMessageOpen: false,
    storeBusyDialog: false,
  };
  analytics = async () => {
    const { settings, product, customerDetails } = this.props;
    if (this.props.settings.enable_fb_pixel && this.props.settings.fb_pixel) {
      const eventId = generateUniqueID(10);
      if (this.props.settings.enable_conversion_api) {
        postPixelEvent("facebook/track/", {
          eventName: "AddToCart",
          customerDetails: customerDetails,
          fbc_2: localStorage.getItem("fbc_2"),
          fb_test_id: getFacebookTestID(),
          url: window.location.href,
          event_id: eventId,
          data: {
            content_ids: [product.id.toString()],
            content_name: product.name,
            currency: settings.currency_iso,
            value: product.price * product.min_addable_quantity,
            quantity: product.min_addable_quantity,
          },
        });
      }
      ReactPixel.track(
        "AddToCart",
        {
          content_ids: [product.id.toString()],
          content_name: product.name,
          content_type: "product",
          currency: settings.currency_iso,
          value: product.price * product.min_addable_quantity,
          event_id: eventId,
        },
        { eventID: eventId },
      );
    }

    if (settings.enable_google_analytics && settings.google_analytics) {
      ReactGA.event({
        category: "Add to Cart",
        action: `User Added ${product.name} to Cart`,
        label: "Add to Cart",
      });

      ReactGA.gtag("event", "add_to_cart", {
        value: product.price * product.min_addable_quantity,
        currency: settings.currency_iso,
        items: [
          {
            item_id: product.id,
            item_name: product.name || "",
            price: product.price,
            quantity: product.min_addable_quantity,
          },
        ],
      });
    }
    if (GTM) {
      GTM.track("add_to_cart", {
        ecommerce: {
          items: [
            {
              item_id: product.id,
              item_name: product.name,
              currency: settings.currency_iso,
              value: product.price,
              quantity: product.min_addable_quantity,
            },
          ],
        },
      });
    }
    if (settings.enable_snap_pixel && settings.snap_pixel) {
      SnapchatAddToCart(
        this.props,
        product,
        product.min_addable_quantity,
        product.price * product.min_addable_quantity,
      );
    }
    if (settings.enable_ackoo && settings.ackoo_api_key) {
      ReactAckoo.addToCart({
        itemId: product.id.toString(),
        name: product.name,
        quantity: product.min_addable_quantity,
        price: product.price,
        currency: settings.currency_iso,
      });
    }
    if (settings.enable_tiktok_pixel && settings.tiktok_pixel) {
      const eventID = `AddToCart-${generateUniqueID(10)}`;

      TiktokPixel.track("AddToCart", {
        content_id: product.id.toString(),
        content_type: "product",
        content_name: product.name,
        quantity: product.min_addable_quantity,
        price: product.price,
        value: product.price * product.min_addable_quantity,
        currency: settings.currency_iso,
        event_id: eventID,
      });
      if (settings.enable_conversion_api_tiktok) {
        postPixelEvent("tiktok/track/", {
          eventName: "AddToCart",
          customerDetails: customerDetails,
          ttclid: localStorage.getItem("ttclid"),
          eventID: eventID,
          url: window.location.href,
          properties: {
            contents: [
              {
                price: product.price,
                content_id: product.id.toString(),
                content_name: product.name,
                content_type: "product",
                quantity: product.min_addable_quantity,
              },
            ],

            description: product.name,
            content_type: "product",
            currency: settings.currency_iso,
            value: product.price * product.min_addable_quantity,
          },
        });
      }
    }
    if (TwitterPixel.isInitialized()) {
      if (settings.twitter_events["Add to Cart"]) {
        TwitterPixel.track(settings.twitter_events["Add to Cart"], {
          contents: [
            {
              content_type: "product",
              content_id: product.id,
              content_name: product.name,
              content_price: product.price,
              num_items: product.min_addable_quantity,
            },
          ],
          email_address: customerDetails?.customerContact?.email,
          phone_number: customerDetails?.customerContact?.phone,
        });
      }
    }

    if (PinterestPixel.isInitialized()) {
      PinterestAddToCart(product, product.min_addable_quantity, product.price);
    }
    if (Klaviyo.isInitialized()) {
      Klaviyo.track(
        "Added to Cart",
        {
          email: customerDetails?.customerContact?.email || "",
          phone_number: customerDetails?.customerContact?.phone || "",
          first_name: customerDetails?.customerContact?.name || "",
        },
        {
          ProductID: product.id.toString(),
          SKU: product.id.toString(),
          ProductName: product.name,
          URL: window.location.href,
          ImageURL: product.price.photo,
          Price: product.price,
          $value: product.price * product.min_addable_quantity,
          Quantity: product.min_addable_quantity,
        },
      );
    }
  };

  removeFromCartAnalytics = () => {
    const { settings, product } = this.props;

    if (settings.enable_google_analytics && settings.google_analytics) {
      ReactGA.event({
        category: "Removed From Cart",
        action: `User Removed ${product.name} From Cart`,
        label: "Removed From Cart",
      });

      ReactGA.gtag("event", "remove_from_cart", {
        value: product.price * product.quantity,
        currency: settings.currency_iso,
        items: [
          {
            item_id: product.id,
            item_name: product.name || "",
            price: product.price,
            quantity: product.quantity,
          },
        ],
      });
    }
    if (GTM) {
      GTM.track("remove_from_cart", {
        ecommerce: {
          items: [
            {
              item_id: product.id,
              item_name: product.name,
              currency: settings.currency_iso,
              value: product.price,
              quantity: product.min_addable_quantity,
            },
          ],
        },
      });
    }
  };

  EditQuantity = (
    index,
    item,
    newQuantity,
    quantity,
    PromoItem,
    isPreordered,
  ) => {
    if (
      this.props.cart[index] &&
      this.props.cart[index].id === item.id &&
      this.quantityToBededucted !== 0
    ) {
      this.props.edit_quantity(
        index,
        item,
        preciseNumber(item.quantity + quantity),
        quantity,
        PromoItem,
        isPreordered,
      );
    }
    this.quantityToBededucted = 0;
  };
  EditQuantityAPIDebounced = AwesomeDebouncePromise(this.EditQuantity, 300);

  componentDidMount = () => {
    if (!this.canQuickAddProductToCart) return;
    const [item, itemIndex, quantity] = this.getAddedQuantity();
    this.setState({ item, itemIndex, quantity });
    if (item && this.props.type == "list") {
      this.props.setIsSelected(true);
    }
  };
  shouldComponentUpdate = (nextProps, nextState) => {
    if (
      nextState.confirmationMessageOpen !==
        this.state.confirmationMessageOpen ||
      nextState.MingledDialogOpen !== this.state.MingledDialogOpen ||
      nextState.scheduledAvailabilityMessageOpen !==
        this.state.scheduledAvailabilityMessageOpen ||
      nextState.storeBusyDialog !== this.state.storeBusyDialog
    )
      return true;

    if (
      this.state.itemIndex >= 0 &&
      (!nextProps.cart[this.state.itemIndex] ||
        nextProps.cart[this.state.itemIndex]?.id !== this.state.item.id ||
        (nextProps.cart[this.state.itemIndex]?.quantity !==
          nextState.quantity &&
          !nextState.changingQuantity))
    ) {
      const [item, itemIndex, quantity] = this.getAddedQuantity(nextProps.cart);

      nextState.quantity = quantity;
      nextState.item = item;
      nextState.itemIndex = itemIndex;

      return true;
    }

    if (
      (nextState.item && !this.state.item) ||
      nextState.quantity != this.state.quantity ||
      nextProps.language != this.props.language
    ) {
      nextState.changingQuantity = false;
      return true;
    }

    return false;
  };
  checkMinMaxOrPromo = (store_product, totalQuantity, PromoItem) => {
    if (
      PromoItem ||
      ((store_product.max_addable_quantity === null ||
        totalQuantity <= store_product.max_addable_quantity) &&
        totalQuantity >= store_product.min_addable_quantity)
    ) {
      return true;
    }

    return false;
  };
  changeQuantity = (
    e,
    item,
    index,
    addedQuantity,
    store_product,
    currentTotalQuantity,
    PromoItem = false,
  ) => {
    e.preventDefault();
    e.stopPropagation();

    const { usedComponents, product } = this.props;
    const newTotalQuantity = preciseNumber(
      addedQuantity + currentTotalQuantity,
    );
    const totalAddedQuantity = preciseNumber(
      addedQuantity + this.quantityToBededucted,
    );
    if (
      preciseNumber(this.state.item.quantity + totalAddedQuantity) <
        store_product.min_addable_quantity ||
      preciseNumber(this.state.item.quantity + totalAddedQuantity) <= 0
    ) {
      this.quantityToBededucted = 0;

      if (this.props.cart[this.state.itemIndex]?.id !== this.state.item.id) {
        const [item, itemIndex, quantity] = this.getAddedQuantity();
        this.props.removeFromCart(itemIndex, item);
        this.removeFromCartAnalytics();
      } else {
        this.props.removeFromCart(this.state.itemIndex, this.state.item);
        this.removeFromCartAnalytics();
      }

      if (this.props.type == "list") {
        this.props.setIsSelected(false);
      }
      return;
    }
    if (
      newTotalQuantity > 0 &&
      this.checkMinMaxOrPromo(store_product, newTotalQuantity, PromoItem) &&
      ((["stocked", "composite"].includes(store_product.type_of_product) &&
        totalAddedQuantity <= getProductInventory(product, usedComponents)) ||
        store_product.type_of_product === "produced" ||
        (store_product.type_of_product === "bookable" &&
          totalAddedQuantity <=
            store_product.booking_slots.find(
              (slot) => slot.id === this.props.item.booking_slot,
            ).inventory)) &&
      newTotalQuantity <=
        getMaximumProductInventoryFromModifiers(
          item.options,
          item.quantity,
          usedComponents,
          null,
          null,
          store_product,
        )
    ) {
      this.quantityToBededucted = totalAddedQuantity;
      this.setState({ quantity: newTotalQuantity, changingQuantity: true });
      this.EditQuantityAPIDebounced(
        index,
        item,
        newTotalQuantity,
        this.quantityToBededucted,
        PromoItem,
        item.is_preordered,
      );
    }
  };
  canQuickAddProductToCart = () => {
    const product = this.props.product;
    if (!product) return false;

    if (
      !["bookable", "service"].includes(product.type_of_product) &&
      !product.has_variants &&
      !product.has_required_options &&
      !product.has_required_extra_fields &&
      !product.no_mingling &&
      !product.pickup_only &&
      !product.delivery_only &&
      !product.cash_only &&
      !product.credit_only &&
      !product.extra_fields.some((field) => field.is_required) &&
      (!product.published_date ||
        moment(product.published_date).isBefore(moment()))
    ) {
      return true;
    }
    return false;
  };
  hasInventory = () => {
    const { product, usedComponents } = this.props;
    if (
      !["stocked", "composite"].includes(product.type_of_product) ||
      getProductInventory(product, usedComponents) >=
        product.min_addable_quantity
    ) {
      return true;
    }
    return false;
  };
  getPostAddRoute = () => getBuyNowCheckoutRoute(this.props.settings, this.props.customerDetails);

  addToCart = (e, quick = false) => {
    const { settings, non_mingled_category, categories } = this.props;

    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const product = this.props.product;

    let parentCategories = null;
    if (product.category_is_child) {
      parentCategories = getParentCategories(product.category_id, categories);
    }
    if (
      this.props.settings.busy_until_active &&
      this.props.settings.busy_until_time &&
      this.props.settings.busy_until_date &&
      !this.props.settings.allow_preordering &&
      ((compareTime(
        this.props.settings.busy_until_time,
        moment().format("HH:mm:ss"),
      ) === 1 &&
        moment(this.props.settings.busy_until_date).format("YYYY-MM-DD") ===
          moment().format("YYYY-MM-DD")) ||
        moment(this.props.settings.busy_until_date).format("YYYY-MM-DD") >
          moment().format("YYYY-MM-DD"))
    ) {
      this.setState({ storeBusyDialog: true });
      return;
    }

    if (non_mingled_category) {
      if (
        product.category_id !== non_mingled_category &&
        parentCategories?.nonMingledParentCategory !== non_mingled_category
      ) {
        this.setState({ MingledDialogOpen: true });
        return;
      }
    } else if (this.props.cart.length) {
      if (
        product.category_no_mingling ||
        parentCategories?.nonMingledParentCategory
      ) {
        this.setState({ MingledDialogOpen: true });
        return;
      }
    }
    if (
      !(
        (!this.props.mingled_item &&
          (!this.props.cart.length || !product.no_mingling)) ||
        (this.props.mingled_item &&
          this.props.cart.length &&
          this.props.cart[0].id === product.id)
      )
    ) {
      this.setState({ MingledDialogOpen: true });
      return;
    }
    if (
      product.confirmation_message &&
      !this.state.confirmationMessageOpen &&
      settings.enable_product_confirmation_messages
    ) {
      this.setState({ confirmationMessageOpen: true });
      return;
    } else if (this.state.confirmationMessageOpen)
      this.setState({ confirmationMessageOpen: false });

    const categoryObj = categories.find(
      (cat) => cat.id === product.category_id,
    );

    let scheduled_available_from = null;
    let scheduled_available_until = null;
    if (
      categoryObj.scheduled_available_from &&
      categoryObj.scheduled_available_until &&
      product.scheduled_available_from &&
      product.scheduled_available_until
    ) {
      if (
        categoryObj.scheduled_available_from > product.scheduled_available_from
      ) {
        scheduled_available_from = categoryObj.scheduled_available_from;
        scheduled_available_until = categoryObj.scheduled_available_until;
      } else {
        scheduled_available_from = product.scheduled_available_from;
        scheduled_available_until = product.scheduled_available_until;
      }
    } else if (
      categoryObj.scheduled_available_from &&
      categoryObj.scheduled_available_until
    ) {
      scheduled_available_from = categoryObj.scheduled_available_from;
      scheduled_available_until = categoryObj.scheduled_available_until;
    } else if (
      product.scheduled_available_from &&
      product.scheduled_available_until
    ) {
      scheduled_available_from = product.scheduled_available_from;
      scheduled_available_until = product.scheduled_available_until;
    }
    if (
      scheduled_available_from &&
      scheduled_available_until &&
      !this.state.scheduledAvailabilityMessageOpen &&
      moment(scheduled_available_from, "YYYY-MM-DDTHH:mm:ss").isAfter(moment())
    ) {
      if (
        this.props.deliveryTime?.expected_date &&
        this.props.deliveryTime?.expected_start
      ) {
        if (
          moment(scheduled_available_from, "YYYY-MM-DDTHH:mm:ss").isAfter(
            moment(
              this.props.deliveryTime.expected_date +
                this.props.deliveryTime.expected_start,
              "YYYY-MM-DDHH:mm:ss",
            ),
          )
        ) {
          this.setState({ scheduledAvailabilityMessageOpen: true });
          return;
        }
      } else {
        this.setState({ scheduledAvailabilityMessageOpen: true });
        return;
      }
    } else if (this.state.scheduledAvailabilityMessageOpen)
      this.setState({ scheduledAvailabilityMessageOpen: false });

    let cartProduct = {
      id: product.id,
      quantity: product.min_addable_quantity,
      category: product.category,
      category_id: product.category_id,
      components: product.components ? product.components : {},
      options: {}, //
      booking_slot: null,
      parent: product.parent,
      total_price: product.price,
      price: product.price,
      is_delivered: product.is_delivered,
      charge_delivery: product.charge_delivery,
      special_request: "",
      preparation_time: product.preparation_time,
      preparation_time_threshold: product.preparation_time_threshold,
      no_mingling: product.no_mingling,
      pickup_only: product.pickup_only,
      delivery_only: product.delivery_only,
      cash_only: product.cash_only,
      credit_only: product.credit_only,
      is_preordered: false,
      preordering_leadtime: 0,
      resource: null,
      resourceSlot: null,
      extraFields: {},
      quantityExcludedOptionsTotal: 0,
      name: product.name,
      category_is_child: product.category_is_child,
      category_no_mingling: product.category_no_mingling,
      parentCategories: parentCategories,
      publishedDate: product.published_date,
      excludeVat: product.exclude_from_vat,
      // productUsedComponents: getProductUsedComponents(product),
    };
    this.props.addToCart(cartProduct);
    if (this.props.type == "list") {
      this.props.setIsSelected(true);
    }
    this.setState({
      quantity: cartProduct.quantity,
      item: cartProduct,
      itemIndex: this.props.cart.length,
    });
    this.analytics();
    if (quick) {
      this.props.history.push(this.getPostAddRoute());
    }
  };
  getAddedQuantity = (cart = this.props.cart) => {
    let quantity = 0;
    const { product } = this.props;
    let item = null;
    let itemIndex = -1;

    for (let i = 0; i < cart.length; i++) {
      if (cart[i].id == product.id && !cart[i].is_preordered) {
        quantity = preciseNumber(quantity + cart[i].quantity);
        if (!item) {
          item = cart[i];
          itemIndex = i;
        }
      }
    }

    return [item, itemIndex, quantity];
  };
  canQuickAddProductToCart = this.canQuickAddProductToCart();
  checkBranchStatus = (e) => {
    // Keep browsing and cart actions on this page. V2 resolves fulfillment in
    // the cart and revalidates these lines once a location has been chosen.
    if (isCheckoutV2Enabled(this.props.settings)) return true;
    if (
      this.props.settings.is_branch_based_ordering &&
      !this.props.branch.branch &&
      !(this.props.settings.branch_count === 1) &&
      !canAddToCartBeforeBranchSelection(this.props.settings)
    ) {
      e.preventDefault();
      e.stopPropagation();
      if (this.props.product.parent) {
        this.props.setNextPage(
          `/product/${this.props.product.category}/${this.props.product.parent}/${this.props.product.slug}`,
        );
      } else {
        this.props.setNextPage(
          `/product/${this.props.product.category}/${this.props.product.slug}`,
        );
      }

      this.props.history.push("/select/branch", {
        pickupOnly: this.props.product.pickup_only,
        deliveryOnly: this.props.product.delivery_only,
      });
      return false;
    }
    return true;
  };
  isPromoProduct = () => {
    const { promotions, product } = this.props;
    if (promotions.products.length || promotions.category_free?.length) {
      return (
        promotions.products
          .filter(
            (p) =>
              p.quantity > 0 &&
              ((p.has_variants && p.product === product.parent) ||
                (!p.has_variants && p.product === product.id)),
          )
          .concat(
            promotions.category_free.filter(
              (cd) =>
                cd.quantity > 0 &&
                cd.categories.includes(product.category_id) &&
                this.isNotExcludedProuduct(cd.promo),
            ),
          ).length > 0
      );
    }
    return false;
  };
  isNotExcludedProuduct = (promoID) => {
    let storeDiscount = this.props.smart_promos.find(
      (promo) => promo.id == promoID,
    );

    if (storeDiscount) {
      return isNotExcludedProuduct(
        this.props.product,
        storeDiscount.excluded_products,
        storeDiscount.excluded_categories,
      );
    }
    return true;
  };
  isInternationalDelivery = () => {
    if (
      (this.props.address?.country !== this.props.baseCountryID ||
        this.props.base_country_name === "Saudi Arabia") &&
      (this.props.settings.enable_dhl ||
        this.props.settings.enable_dhl_v2 ||
        this.props.settings.enable_aramex) &&
      this.props.address?.selectedDeliveryType === 0
    )
      return true;
    return false;
  };
  render() {
    const { language, type, product, settings } = this.props;
    if (!product) return <></>;
    const merchandisingV2 = isEnabledFlag(settings.storefront_merchandising_v2);

    const themeColor = this.props.themeColor
      ? this.props.themeColor
      : "#0099cc";
    const {
      item,
      itemIndex,
      quantity,
      MingledDialogOpen,
      confirmationMessageOpen,
      scheduledAvailabilityMessageOpen,
      storeBusyDialog,
    } = this.state;

    const checkLayout = () => {
      return (
        !(
          settings.store_layout === "jumbo" ||
          settings.store_layout === "list" ||
          settings.store_layout === "list-collapse"
        ) && !this.props.fromRecommendations
      );
    };
    const checkForBuyNow =
      settings.enable_quick_checkout &&
      checkLayout() &&
      product.enable_buy_now &&
      !(this.props.isSearch || this.props.isFilter);
    return (
      <>
        <div onClick={(e) => e.stopPropagation()}>
          <MingledDialog
            dialogOpen={MingledDialogOpen}
            onClose={(e) => {
              this.setState({ MingledDialogOpen: false });
              e.stopPropagation();
            }}
          />
        </div>
        <div onClick={(e) => e.stopPropagation()}>
          <StoreClosedDialog
            dialogOpen={storeBusyDialog}
            onClose={(e) => {
              this.setState({ storeBusyDialog: false });
              e.stopPropagation();
            }}
            untilDate={this.props.settings.busy_until_date}
            untilTime={this.props.settings.busy_until_time}
          />
        </div>
        {settings.enable_product_confirmation_messages && (
          <div onClick={(e) => e.stopPropagation()}>
            <ConfirmationMessageDialog
              dialogOpen={confirmationMessageOpen}
              yes={(e) => {
                this.addToCart(e);
                e.stopPropagation();
              }}
              onClose={(e) => {
                this.setState({
                  confirmationMessageOpen: false,
                });
                e.stopPropagation();
              }}
              confirmationMessage={product.confirmation_message}
            />
          </div>
        )}

        <div onClick={(e) => e.stopPropagation()}>
          <ScheduledAvailableMessage
            dialogOpen={scheduledAvailabilityMessageOpen}
            yes={(e) => {
              this.addToCart(e);
              e.stopPropagation();
            }}
            onClose={(e) => {
              this.setState({
                scheduledAvailabilityMessageOpen: false,
              });
              e.stopPropagation();
            }}
            product={product}
            category={this.props.categories.find(
              (cat) => cat.id === product.category_id,
            )}
          />
        </div>

        {!item ? (
          <div
            className={merchandisingV2 ? "sf-quick-add-actions" : checkForBuyNow ? "d-flex justify-content-around" : ""}
          >
            <Button
              onClick={async (e) => {
                this.checkBranchStatus(e) &&
                  this.hasInventory() &&
                  this.canQuickAddProductToCart &&
                  !this.isPromoProduct() &&
                  this.addToCart(e);
                if (
                  this.props.fromRecommendations &&
                  this.props.fromCheckout &&
                  this.isInternationalDelivery()
                ) {
                  if (
                    (settings.enable_dhl && settings.enable_dhl_dynamic_rate) ||
                    settings.enable_dhl_v2
                  ) {
                    this.props.getDHLQuote();
                  } else if (settings.enable_aramex) {
                    this.props.getAramexRate();
                  }
                }
              }}
              className={merchandisingV2 ? "sf-quick-add-actions__add" : checkForBuyNow ? "" : "mx-auto"}
              variant="outlined"
              color="primary"
              disableRipple
              disableElevation
              size={"small"}
              style={merchandisingV2 ? undefined : {
                height: 30,

                width: checkForBuyNow ? "45%" : "100%",
                fontWeight: "bold",
                border: "1px solid",
                direction: language === "arabic" && "ltr",
                textTransform: "none",
                fontSize: 14,
              }}
              dir={merchandisingV2 ? (language === "arabic" ? "rtl" : "ltr") : undefined}
              startIcon={(merchandisingV2 || language !== "arabic") && <AddOutlined />}
              endIcon={!merchandisingV2 && language === "arabic" && <AddOutlined />}
            >
              <span>{language === "arabic" ? "أضف" : "Add"}</span>
            </Button>

            {checkForBuyNow && (
              <Button
                className={merchandisingV2 ? "sf-quick-add-actions__buy" : undefined}
                onClick={(e) => {
                  this.checkBranchStatus(e) &&
                    this.hasInventory() &&
                    this.canQuickAddProductToCart &&
                    !this.isPromoProduct() &&
                    this.addToCart(e, true);
                }}
                variant={merchandisingV2 ? "contained" : "outlined"}
                color="primary"
                disableRipple
                disableElevation
                size={"small"}
                style={merchandisingV2 ? undefined : {
                  height: 30,
                  width: "45%",
                  fontWeight: "bold",
                  border: "1px solid #2ecc71",
                  direction: language === "arabic" && "ltr",
                  textTransform: "none",
                  // fontSize:language === "english"? 11 : 10,
                  fontSize: 14,
                  backgroundColor: "#2ecc71",
                  color: "white",
                  whiteSpace: "nowrap",
                }}
              >
                <span>{language === "english" ? "Buy now" : "اشتر الآن"}</span>
              </Button>
            )}
          </div>
        ) : (
          <Grid
            direction={
              language == "arabic"
                ? type === "list"
                  ? "row-reverse"
                  : "column-reverse"
                : ""
            }
            className="mx-auto"
            alignItems="center"
            justify="space-around"
            container
            style={{
              width: "100%",
              height: 30,
              position: "relative",
            }}
          >
            <Grid
              item
              onClick={async (e) => {
                this.changeQuantity(
                  e,
                  item,
                  itemIndex,
                  parseFloat(-this.props.product.increments),
                  this.props.product,
                  quantity,
                  false,
                );
                if (
                  this.props.fromRecommendations &&
                  this.props.fromCheckout &&
                  this.isInternationalDelivery()
                ) {
                  if (
                    (settings.enable_dhl && settings.enable_dhl_dynamic_rate) ||
                    settings.enable_dhl_v2
                  ) {
                    this.props.getDHLQuote();
                  } else if (settings.enable_aramex) {
                    this.props.getAramexRate();
                  }
                }
              }}
              className="option-quantity-button"
            >
              <RemoveCircleOutline style={{ color: themeColor }} />
            </Grid>
            <Grid item>
              <div
                className="text-center"
                style={{
                  color: themeColor,
                  border: "0.5px solid #DEDEDE",
                  borderRadius: 5,
                  minWidth: 30,
                  padding: 1,
                }}
              >
                {quantity}
              </div>
            </Grid>
            <Grid
              item
              onClick={async (e) => {
                this.changeQuantity(
                  e,
                  item,
                  itemIndex,
                  parseFloat(this.props.product.increments),
                  this.props.product,
                  quantity,
                  false,
                );
                if (
                  this.props.fromRecommendations &&
                  this.props.fromCheckout &&
                  this.isInternationalDelivery()
                ) {
                  if (
                    (settings.enable_dhl && settings.enable_dhl_dynamic_rate) ||
                    settings.enable_dhl_v2
                  ) {
                    this.props.getDHLQuote();
                  } else if (settings.enable_aramex) {
                    this.props.getAramexRate();
                  }
                }
              }}
              className="option-quantity-button"
            >
              <AddCircleOutline style={{ color: themeColor }} />
            </Grid>
          </Grid>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    themeColor: state.store.store.settings.dark,
    cart: state.cart.cart,
    settings: state.store.store.settings,
    branch: state.branch,
    usedComponents: state.store.used_components,
    categories: state.store.store.categories,
    non_mingled_category: state.cart.non_mingled_category,
    deliveryTime: state.deliveryTime,
    customerDetails: state.customers,
    promotions: state.cart.discounts,
    smart_promos: state.store.store.smart_promos,
    address: state.customers.address,
    base_country_name: state.store.store.base_country,
    mingled_item: state.cart.mingled_item,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (product, history) => dispatch(add_to_cart(product, history)),
    removeFromCart: (item_index, item) =>
      dispatch(remove_from_cart(item_index, item)),
    edit_quantity: (
      item,
      product_index,
      product,
      quantity,
      change,
      PromoItem,
      isPreordering,
    ) =>
      dispatch(
        edit_quantity(
          item,
          product_index,
          product,
          quantity,
          change,
          PromoItem,
          isPreordering,
        ),
      ),
    setNextPage: (nextPage) =>
      dispatch({ type: "SET_NEXT_PAGE", payload: nextPage }),
    getDHLQuote: () => dispatch(getDHLQuote()),
    getAramexRate: () => dispatch(getAramexRate()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(QuickAddToCart));
